import { render, staticRenderFns } from "./PortfolioPage.vue?vue&type=template&id=3b2345ec&"
import script from "./PortfolioPage.vue?vue&type=script&lang=js&"
export * from "./PortfolioPage.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioPage.vue?vue&type=style&index=0&id=3b2345ec&prod&lang=scss&"
import style1 from "./PortfolioPage.vue?vue&type=style&index=1&id=3b2345ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports